/*
 * @Description: 
 * @Author: ke wen
 * @Date: 2021-01-21 16:56:00
 * @LastEditTime: 2021-02-27 15:27:14
 * @LastEditors: LastEditors
 * @Reference: 
 */
import Cookies from 'js-cookie'

const TokenKey = 'djAccessToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRemainderTime(remainingTime) {
    remainingTime = Math.ceil(remainingTime/1000)
    var day = Math.floor(remainingTime / 86400);
    remainingTime = remainingTime % 86400;
    var hour = Math.floor(remainingTime / 3600);
    remainingTime = remainingTime % 3600;
    var minute = Math.floor(remainingTime / 60);
    remainingTime = remainingTime % 60;
    var second = remainingTime;
    let allFieldList = {
        dd: day,
        hh: hour < 10 ? '0' + hour : hour,
        mm: minute < 10 ? '0' + minute : minute,
        ss: second < 10 ? '0' + second : second
    }
    return allFieldList
    // let {dd,hh,mm,ss}=allFieldList
    // return `${dd>0?dd+'Day':''} ${hh}:${mm}:${ss}`
} 